export const ConfigTypes = {
  REFRESH: 'REFRESH'
};
